import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxsModule } from '@ngxs/store';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { HttpClientModule } from '@angular/common/http';
import { ToastNoAnimationModule } from 'ngx-toastr';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './modules/shared/shared.module';
import { UtmState } from './states/utm.state';
import { WebModule } from './modules/web/web.module';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { LoadingBarModule, LOADING_BAR_CONFIG } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { DecimalPipe } from '@angular/common';
import {TransferHttpCacheModule} from '@nguniversal/common';
import { NgxCaptchaModule } from 'ngx-captcha';
import { CoreModule } from './core/core.module';
import { AuthState } from './states/auth.state';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'Pishkar' }),
    TransferHttpCacheModule,
    AppRoutingModule,
    FormsModule,
    ServiceWorkerModule.register('/ngsw-worker-extend.js', { enabled: environment.production }),
    NgxsModule.forRoot([AuthState, UtmState], { developmentMode: !environment.production }),
    NgxsStoragePluginModule.forRoot(),
    HttpClientModule,
    ToastNoAnimationModule.forRoot({ preventDuplicates: true }),
    InfiniteScrollModule,
    NgxSmartModalModule.forRoot(),
    NgSelectModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,
    TooltipModule.forRoot(),
    NgxCaptchaModule,
    CoreModule,
    SharedModule,
    WebModule,
  ],
  providers: [
    { provide: LOADING_BAR_CONFIG, useValue: { latencyThreshold: 500 } },
    DecimalPipe
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
